import {
  apiClient,
  createIdempotencyKey,
} from "../../shared/api/httpClient.js";

export async function getMyProviderOnboarding() {
  try {
    const response = await apiClient.get("/providers/me/");
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
}

export async function submitProviderApplication() {
  const response = await apiClient.post("/providers/applications/");
  return response.data;
}

export async function acceptProviderAgreement(payload) {
  const response = await apiClient.post(
    "/providers/me/agreements/acceptances/",
    payload,
  );
  return response.data;
}

export async function listSettlementRecipients() {
  const response = await apiClient.get("/providers/me/settlement-recipients/");
  return response.data;
}

export async function startSettlementRecipientBinding(channel = "ALIPAY") {
  const response = await apiClient.post(
    "/providers/me/settlement-recipients/",
    {
      channel,
      client_request_id: createIdempotencyKey("settlement-recipient"),
    },
  );
  return response.data;
}
